/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
if (typeof lazySizes !== 'function' && typeof lazySizes !== 'object' || typeof lazySizes === 'undefined'){
	/*! lazysizes - v4.1.8 */
	!function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
	/*! ls.rias.min.ks - v4.1.8 */
	!function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

// Override Settings
const boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		loadProductFirst: false,
		// Placeholder
		showPlaceholderProductList: true,
		placeholderProductPerRow: 3,
		placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
		enableOTP: true,
		defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
		selectOptionContainer: '.boost-pfs-filter-product-item-image'  // CSS selector to append the product option, if left empty it will append to the product item
	},
	selector: {
		otpButtons: '.boost-pfs-filter-product-item-image'
	}
};

(function () {
	let onSale = false,
		soldOut = false,
		hasOnlyDefaultVariant = true,
		priceVaries = false,
		images = [],
		firstVariant = {},
		boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
		boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

	const isTouchDevice = window.matchMedia("(-moz-touch-enabled: 1), (hover: none)").matches;

	BoostPFS.inject(this);
	boostPFSFilterConfig.general.separateRefineByFromFilter = (jQ('.boost-pfs-filter-tree-h').length && !Utils.isMobile() > 0 && boostPFSThemeConfig.custom.filter_tree_horizontal_style !== 'style-expand');

	Selector.stickyElstickyElementDesktopementDesktop = jQ('.boost-pfs-filter-tree-v').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';

	let productGridItemIndex = 1;
	const collectionBanners = [...document.querySelectorAll("[data-collection-banner]")];

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		hasOnlyDefaultVariant = data.variants.length === 1;

		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		priceVaries = data.price_min !== data.price_max; // Check a product has many prices

		// Convert images to array
		images = data.images_info;

		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];

		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			let paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});

			if (typeof paramVariant[0] !== 'undefined') {
				firstVariant = paramVariant[0];
			}
		} else {
			for (let i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}

		onSale = firstVariant.compare_at_price > firstVariant.price; // Check if current variant is on sale

		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) {
			data = this.data;
		}

		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		let template = this.buildTemplate(data);

		return template;
	};

	ProductGridItem.prototype.buildTemplate = function (product) {
		let template = '';

		const currentCollectionBanner = collectionBanners.find((banner) => {
			return parseInt(banner.dataset.collectionBannerPosition) === productGridItemIndex;
		});

		if (currentCollectionBanner) {
			template += buildCollectionBanner(currentCollectionBanner);
		}

		let currentProductGridItemIndex = productGridItemIndex++;


		//BONUS SEEDS TEMPLATE
		if (window.boostPFSThemeConfig?.custom?.is_bonus_seeds) {
			return buildBonusSeedsTemplate(product,template,currentProductGridItemIndex);
		}

		template += window.boostPFSTemplate.productGridItemHtml.replace(/{{productId}}/g, product.id);

		let imagesHtml 	= buildProductCardImages(product);
		let bagdesHtml 	= buildProductCardBadges(product);
		let metaHtml 	= buildProductCardMeta(product);
		let titleHtml 	= buildProductTitle(product);
		let formHtml    = buildProductCardForm(product);
		let wishHtml    = buildWishlistButton(product);
		let subscriptionsProduct    = isSubscriptionsProduct(product);

		template = template.replace(/{{productImages}}/g, imagesHtml);
		template = template.replace(/{{productBadges}}/g, bagdesHtml);
		template = template.replace(/{{productTitle}}/g, titleHtml);
		template = template.replace(/{{productMeta}}/g, metaHtml);
		template = template.replace(/{{productForm}}/g, formHtml);
		template = template.replace(/{{subscriptionsProduct}}/g, subscriptionsProduct);

		// Add main attribute (Always put at the end of this function)
		template = template.replace(/{{itemId}}/g, product.id);
		template = template.replace(/{{itemVariants}}/g, product.variants);
		template = template.replace(/{{itemTitle}}/g, product.title);
		template = template.replace(/{{itemHandle}}/g, product.handle);
		template = template.replace(/{{itemVendorLabel}}/g, product.vendor);
		template = template.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(product));
		template = template.replace(/{{itemIndex}}/g, currentProductGridItemIndex);
		template = template.replace(/{{wishlistButton}}/g, wishHtml);

		return template;
	};

	// Build Product List Item
	ProductListItem.prototype.compileTemplate = function (data) {
		if (!data) {
			data = this.data;
		}

		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		let template = this.buildTemplate(data);

		return template;
	};

	ProductListItem.prototype.buildTemplate = function (product) {
		let template = boostPFSTemplate.productListItemHtml.replace(/{{productId}}/g, product.id);

		let imagesHtml 	= buildProductCardImages(product);
		let bagdesHtml 	= buildProductCardBadges(product);
		let metaHtml 	= buildProductCardMeta(product);

		template = template.replace(/{{productImages}}/g, imagesHtml);
		template = template.replace(/{{productBadges}}/g, bagdesHtml);
		template = template.replace(/{{productMeta}}/g, metaHtml);

		// Add main attribute (Always put at the end of this function)
		template = template.replace(/{{itemId}}/g, product.id);
		template = template.replace(/{{itemTitle}}/g, product.title);
		template = template.replace(/{{itemHandle}}/g, product.handle);
		template = template.replace(/{{itemVendorLabel}}/g, product.vendor);
		template = template.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(product));

		return template;
	};
	/************************** END BUILD PRODUCT LIST **************************/

	/************************** BUILD BONUS SEEDS GRID ITEM **************************/
	function buildBonusSeedsTemplate(product,template,currentProductGridItemIndex) {
		template += window.boostPFSTemplate.bonusSeedsProductGridItemHtml.replace(/{{productId}}/g, product.id);

		let imagesHtml 	= buildBonusSeedsProductCardImages(product);
		let metaHtml 	= buildBonusSeedsProductCardMeta(product);
		let titleHtml 	= buildProductTitle(product);
		let formHtml    = buildProductCardForm(product);
		let selectHtml  = buildBonusSeedsSelectButton(product);

		template = template.replace(/{{productImages}}/g, imagesHtml);
		template = template.replace(/{{productAvailable}}/g, product.variants[0].available);
		template = template.replace(/{{productTitle}}/g, titleHtml);
		template = template.replace(/{{productMeta}}/g, metaHtml);
		template = template.replace(/{{productForm}}/g, formHtml);
		template = template.replace(/{{selectButton}}/g, selectHtml);

		// Add main attribute (Always put at the end of this function)
		template = template.replace(/{{itemId}}/g, product.id);
		template = template.replace(/{{itemVariants}}/g, product.variants);
		template = template.replace(/{{itemTitle}}/g, product.title);
		template = template.replace(/{{itemHandle}}/g, product.handle);
		template = template.replace(/{{itemVendorLabel}}/g, product.vendor);
		template = template.replace(/{{itemUrl}}/g, window.Utils.buildProductItemUrl(product));
		template = template.replace(/{{itemIndex}}/g, currentProductGridItemIndex);
		template = template.replace(/{{firstVariantId}}/g, product.variants[0].id);

		return template;
	}
	/************************** ENDBUILD BONUS SEEDS GRID ITEM **************************/

	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function getProductUrl(product) {
		return Utils.buildProductItemUrl(product);
	}

	function getVariantUrl(product) {
		return `/products/${product.handle}?variant=${firstVariant.id}`;
	}

	function buildBonusSeedsProductCardImages(product) {
		if (!product) {
			return '';
		}

		const productUrl = getProductUrl(product);


		const featuredImage = () => {

			let image;

			if (Object.keys(product.images).length > 0 ) {

				image = Utils.getFeaturedImage(images).replace('_large.jpg', '.jpg').replace('_large.png', '.png');

			}
			else{
				image = Utils.getFilePath(product.featured_image.replace('.png', '').replace('.jpg', '').replace('files/', ''));
			}

			let src = image;
			let alt = product.title;

			return `<img srcset="
                  ${src.replace('.jpg', '_331x.jpg').replace('.png', '_331x.png')} 331w,
                  ${src.replace('.jpg', '_480x.jpg').replace('.png', '_480x.png')} 480w,
                  ${src.replace('.jpg', '_640x.jpg').replace('.png', '_640x.png')} 640w,
                  ${src.replace('.jpg', '_851x.jpg').replace('.png', '_851x.png')} 851w
                "
                src="${src.replace('.jpg', '_331x.jpg').replace('.png', '_331x.png')}"
                sizes="
				  (min-width: 1200px) calc((100vw - 116px) / 4),
                  (min-width: 768px) calc((100vw - 80px) / 4),
                  (min-width: 640px) calc((100vw - 64px) / 3),
                  calc((100vw - 48px) / 2)
                "
                alt="${alt}"
                class="motion-reduce"
                  loading="lazy"
                width="331"
                height="331"
              >`;

		};

		const productImages = `<div class="card__media">
									<div class="media media--hover-effect">
										${featuredImage()}
									</div>
								</div>
							`;

		return `${productImages}`;
	}
	function buildProductCardImages(product) {
		if (!product) {
			return '';
		}

		const productUrl = getProductUrl(product);


		const featuredImage = () => {

			let image;

			if (Object.keys(product.images).length > 0 ) {

				image = Utils.getFeaturedImage(images).replace('_large.jpg', '.jpg').replace('_large.png', '.png');

			}
			else{
				image = Utils.getFilePath(product.featured_image.replace('.png', '').replace('.jpg', '').replace('files/', ''));
			}

			let src = image;
			let alt = product.title;

			return `<img srcset="
                  ${src.replace('.jpg', '_331x.jpg').replace('.png', '_331x.png')} 331w,
                  ${src.replace('.jpg', '_480x.jpg').replace('.png', '_480x.png')} 480w,
                  ${src.replace('.jpg', '_640x.jpg').replace('.png', '_640x.png')} 640w,
                  ${src.replace('.jpg', '_851x.jpg').replace('.png', '_851x.png')} 851w
                "
                src="${src.replace('.jpg', '_331x.jpg').replace('.png', '_331x.png')}"
                sizes="
				  (min-width: 1200px) calc((100vw - 116px) / 4),
                  (min-width: 768px) calc((100vw - 80px) / 4),
                  (min-width: 640px) calc((100vw - 64px) / 3),
                  calc((100vw - 48px) / 2)
                "
                alt="${alt}"
                class="motion-reduce"
                  loading="lazy"
                width="331"
                height="331"
              >`;

		};

		const productImages = `<a href="${productUrl}" class="full-unstyled-link">
								<div class="card__media">
									<div class="media media--hover-effect">
										${featuredImage()}
									</div>
								</div>
							</a>`;

		return `${productImages}`;
	}

	function buildProductCardBadges(product) {
		if (!product) {
			return '';
		}

		let tags = product.tags.join(', ').toLowerCase();

		const isOutOfStock = () => {
			const inventoryPolicy = firstVariant?.inventory_policy;

			if (inventoryPolicy === "continue" || !inventoryPolicy) {
				return false;
			}

			return firstVariant?.inventory_quantity < 1;
		};

		let hasSaleBadge = () => {

			if (!product.variants[0].compare_at_price){
				return '';
			}

			let sale = '';
			let compare_at_price = product.variants[0].compare_at_price.toFixed(2).replace('.', '');
			let price = product.variants[0].price.toFixed(2).replace('.', '');

			sale = Math.floor((compare_at_price - price) * 100 / compare_at_price);

			return `${sale}%`;

		};

		const isNew = () => {
			const days = 7;

			const dayNow = new Date();
			const dayPublished = new Date(product.published_at);

			const dayFinished = dayPublished.setDate(dayNow.getDate() + days);

			return new Date(dayFinished) > new Date(dayNow);
		};

		let badgeOutOfStock = '';
		let badgeSale = '';
		let badgeNew = '';
		let badgeBackInStock = '';
		let badgeLimitedEdition = '';
		let badgeNewProduct = '';
		let badgeRefill = '';

		if (isOutOfStock() && product.handle !== 'gift-card') {
			badgeOutOfStock = boostPFSTemplate.badgeOutOfStockHtml;
		}

		if (hasSaleBadge()) {
			badgeSale = boostPFSTemplate.badgeSaleHtml.replace(/{{savePrice}}/g, hasSaleBadge(product));
		}

		if (isNew()) {
			badgeNew = boostPFSTemplate.badgeNewHtml;
		}

		if (tags.includes('back in stock')) {
			badgeBackInStock = boostPFSTemplate.badgeBackInStockHtml;
		}

		if (tags.includes('limited edition')) {
			badgeLimitedEdition = boostPFSTemplate.badgeLimitedEditionHtml;
		}

		if (tags.includes('new product')) {
			badgeNewProduct = boostPFSTemplate.badgeNewProductHtml;
		}

		if (tags.includes('refillme')) {
			badgeRefill = boostPFSTemplate.badgeRefillHtml;
		}

		if (badgeOutOfStock) {
			badgeSale = '';
			badgeBackInStock = '';
		}

		if (badgeNew) {
			badgeBackInStock = '';
		}

		return `
			${badgeOutOfStock}
			${badgeSale}
			${badgeNew}
			${badgeBackInStock}
			${badgeLimitedEdition}
			${badgeNewProduct}
			${badgeRefill}
		`;
	}

	function buildWishlistButton(product) {
		if (!product) {
			return '';
		}

		const variantUrl = getVariantUrl(product);

		return `
          <button
          	type="button"
            class="swym-button swym-add-to-wishlist-view-product product_{{product_id}}"
            data-with-epi="true"
            data-swaction="addToWishlist"
            data-product-id="${product.id}"
            data-variant-id="${product.variants[0].id}"
			data-product-url="https://${window.Shopify.shop}${variantUrl}"
          >
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="i-wishlist">
\t<path
\t\td="M17.3666 3.84172C16.941 3.41589 16.4356 3.0781 15.8794 2.84763C15.3232 2.61716 14.727 2.49854 14.1249 2.49854C13.5229 2.49854 12.9267 2.61716 12.3705 2.84763C11.8143 3.0781 11.3089 3.41589 10.8833 3.84172L9.99994 4.72506L9.1166 3.84172C8.25686 2.98198 7.0908 2.49898 5.87494 2.49898C4.65908 2.49898 3.49301 2.98198 2.63327 3.84172C1.77353 4.70147 1.29053 5.86753 1.29053 7.08339C1.29053 8.29925 1.77353 9.46531 2.63327 10.3251L3.5166 11.2084L9.99994 17.6917L16.4833 11.2084L17.3666 10.3251C17.7924 9.89943 18.1302 9.39407 18.3607 8.83785C18.5912 8.28164 18.7098 7.68546 18.7098 7.08339C18.7098 6.48132 18.5912 5.88514 18.3607 5.32893C18.1302 4.77271 17.7924 4.26735 17.3666 3.84172V3.84172Z"
\t\tstroke="#003A85" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
			</button>`;
	}

	function buildProductTitle(product) {
		if (!product) {
			return '';
		}
		const productUrl = getProductUrl(product);

		const productTitle = () => {
			return `<h3 class="card__heading"
					id="title-${product.id}">
						<a href="${productUrl}" class="full-unstyled-link">
							${product.title}
						</a>
					</h3>`;
		};

		return `${productTitle()}`;
	}

	function buildBonusSeedsSelectButton() {

		return `
		<button class="bonus-seeds__select-button"
        type="button">
        Select
        </button>
        <button class="bonus-seeds__select-button bonus-seeds__select-button--selected"
        type="button">
        Selected
        </button>
        <button class="bonus-seeds__select-button bonus-seeds__select-button--sold-out"
        disabled
        type="button">
        Sold out
        </button>
        `;
	}

	function buildBonusSeedsProductCardMeta(product) {
		if (!product) {
			return '';
		}

		const productSKU = () => {

			if (!product) {
				return '';
			}

			return `<div class="card__sku">
            <span>${product.variants[0].title}</span>
            <span class="card__sku-separator">|</span>
			<span>SKU: ${product.variants[0].sku}</span>
			</div>`;
		};

		const productDescription = () => {
			// console.log(product);
			return `<div class="card__description">
				${product.description.split('.')[0]}
			</div>`;
		};

		const productTags = () => {
			let badgeHtml = '';
			product.tags.forEach((tag)=>{

				if (tag.includes('badge::')) {
					let badge = tag.split('::')[1];
					badge = badge.replace('-', ' ').charAt(0).toUpperCase() + badge.slice(1); //capitalize
					// console.log(badge);

					badgeHtml += `<div class="card__tags-tag">
						${badge}
					</div>`;
				}

			});

			return `<div class="card__tags">${badgeHtml}</div>`;
		};

		return `
			${productDescription()}
			${productSKU()}
			${productTags()}
		`;

	}

	function buildProductCardMeta(product) {
		if (!product) {
			return '';
		}

		const productSKU = () => {

			if (!product) {
				return '';
			}

			return `<div class="card__sku">
            <span>${product.variants[0].title}</span>
            <span class="card__sku-separator">|</span>
			<span>SKU: ${product.variants[0].sku}</span>
			</div>`;
		};

		const productDescription = () => {
			// console.log(product);
			return `<div class="card__description">
				${product.description.split('.')[0]}
			</div>`;
		};

		const productPrice = () => {
			const minComparePrice = product.compare_at_price_min;
			const minPrice = product.price_min;
			const hasSale = minComparePrice > minPrice;
			let saleClass = '';
			let fromLabel = '';

			if (hasSale) {
				saleClass = 'price--on-sale';
			}

			if (product.variants[1]) {
				fromLabel = 'From: ';
			}

			return `<div class="card__price">
						<div class="price ${saleClass}">
							<div class="price__container">
								<div class="price__regular">
									<span class="visually-hidden visually-hidden--inline">Regular price</span>
									<span class="price-item price-item--regular">
										${Utils.formatMoney(minPrice)}
									</span>
								</div>
								<div class="price__sale">
									<span class="visually-hidden visually-hidden--inline">Sale price</span>
									<span class="price-item price-item--sale price-item--last">
										${Utils.formatMoney(minPrice)}
									</span>
									<span class="visually-hidden visually-hidden--inline">Regular price</span>
									<span>
										<s class="price-item price-item--regular">
										 ${Utils.formatMoney(minComparePrice)}
							            </s>
									</span>
								</div>
							</div>
						</div>
					</div>`;
		};

		const productTags = () => {

			let badgeHtml = '';

			product.tags.forEach((tag)=>{

				if (tag.includes('badge::')) {
					let badge = tag.split('::')[1];
					badge = badge.replace('-', ' ').charAt(0).toUpperCase() + badge.slice(1); //capitalize
					// console.log(badge);

					badgeHtml += `<div class="card__tags-tag">
						${badge}
					</div>`;
				}

			});

			return `<div class="card__tags">${badgeHtml}</div>`;
		};

		return `
			${productDescription()}
			${productSKU()}
			${productPrice()}
			${productTags()}
		`;
	}

	function isSubscriptionsProduct(product) {
		if (product.product_type === 'Subscriptions') {
			return 'hidden';
		} else {
			return '';
		}
	}
	function buildProductCardForm(product) {

		if (!product) {
			return '';
		}

		const productId = product.id;

		const productForm = () => {
			const currentVariantId = firstVariant?.id;


			if (!currentVariantId) {
				return '';
			}

			const inventoryPolicy = firstVariant?.inventory_policy;
			const inventoryQuantity = firstVariant?.inventory_quantity;

			// Product Button

			let cardButton = `<button type="submit" name="add" class="button button--primary">
					<span data-product-price>${Utils.formatMoney(firstVariant.price)}</span>&nbsp;- Add to Cart
						<div class="loading-overlay__spinner hidden">
						<svg aria-hidden="true" class="spinner icon" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" cx="33" cy="33" r="30" /></svg>
						</div>
					</button>`;

			if ((firstVariant.inventory_quantity < 1) && (firstVariant.fulfillment_service !== 'gift_card') && (inventoryPolicy !== 'continue')) {
				cardButton = `<button type="submit" name="add" class="button button--primary" disabled>Sold out</button>`;
			}



			// Out of stock Form

			if (inventoryPolicy === "deny" && inventoryQuantity < 1 && firstVariant.fulfillment_service !== 'gift_card') {
				return boostPFSTemplate.productFormOutOfStockHtml.replace(/{{variantId}}/g, currentVariantId).replace(/{{cardButton}}/g, cardButton);
			}



			// productVariantsList
			let optionsArray = '';

			// check if Product has options
			let singleProduct = '';
			if (product.options[0] == 'title'){
				singleProduct = 'hidden';
			}

			product.variants.forEach((variant, index)=> {
    			let soldOut = '';
    			let variantDisabled = '';
    			let onlyB2B = false;
    			let selectedTag = 'selected="selected"';

				if (index !== 0) {
					selectedTag = '';
				}
				if (variant.inventory_quantity < 1 && variant.fulfillment_service !== 'gift_card' && variant.inventory_policy != 'continue') {
					variantDisabled = 'disabled';
					soldOut = ' - Sold out';
				}

				const lastChar = variant?.sku?.[variant.sku.length - 1];
				// boostPFSThemeConfig.custom.customer_type
				if (lastChar?.toLowerCase() === 'w') {
					onlyB2B = true;
				}

				if (onlyB2B && !boostPFSThemeConfig.custom.customer_b2b) {
					return;
				}

				optionsArray += `<option ${selectedTag} ${variantDisabled} data-variant-price="${(variant.price).toFixed(2).replace('.', '')}" value="${variant.id}">${variant.title}${soldOut}</option>`;

			});

			let variantSelectList = `<select
			name="id_selector"
			id="Option-${productId}"
			class="select__select"
			form="product_form_${productId}">
			${optionsArray}</select>`;

			return boostPFSTemplate.productFormHtml.replace(/{{variantId}}/g, currentVariantId).replace(/{{variantSelect}}/g, variantSelectList).replace(/{{cardButton}}/g, cardButton).replace(/{{singleProduct}}/g, singleProduct);
		};

		return `
		${productForm()}
		`;
	}
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/

	/************************** BUILD BANNER **************************/
	function buildCollectionBanner(banner) {
		if (!banner) {
			return '';
		}

		return banner.innerHTML;
	}
	/************************** END BUILD BANNER **************************/

	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) {
			totalProduct = this.totalProduct;
		}

		// Get page info
		var currentPage = parseInt(Utils.stripHtml(Globals.queryParams.page));
		var totalPage = Math.ceil(totalProduct / Utils.stripHtml(Globals.queryParams.limit));

		if (!currentPage || isNaN(currentPage)) {
			currentPage = 1;
		}

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];

		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}

		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}

		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}

		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];

		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}

		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}

		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);

		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}

			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}

		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		let html = '';

		if (!boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			return false;
		}

		const sortingArr = Utils.getSortingList();

		if (!sortingArr) {
			return false;
		}

		let paramSort = Globals.queryParams.sort || '';

		// Build content
		let sortingItemsHtml = '';

		for (let k in sortingArr) {
			let activeClass = '';

			if (paramSort == k) {
				activeClass = ' active';
			}

			sortingItemsHtml += `<li class="collection-sorting__dropdown-item${activeClass}">
									<button type="button" class="boost-pfs-filter-top-sorting-dropdown-option collection-sorting__value" data-sort="${k}">
										${sortingArr[k]}
									</button>
								</li>`;
		}

		html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);

		return html;
	};

	ProductSorting.prototype.render = function () {
		const selectors = {
			container: '.boost-pfs-filter-custom-sorting',
			button: '.boost-pfs-filter-top-sorting-dropdown-button'
		};

		const container = jQ(selectors.container);

		if (!container.length) {
			return false;
		}

		const html = this.compileTemplate();

		container.html(html);

		let labelSort = '';

		const paramSort = Globals.queryParams.sort || '';
		const sortingList = Utils.getSortingList();

		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		const button = jQ(selectors.button);
		button.text(labelSort);
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		const selectors = {
			dropdownTrigger: '.boost-pfs-filter-top-sorting-dropdown-trigger',
			dropdownTriggerButton: '.boost-pfs-filter-top-sorting-dropdown-button',
			option: '.boost-pfs-filter-top-sorting-dropdown-option'
		};

		const dropdownTrigger = jQ(selectors.dropdownTrigger);
		const dropdownTriggerButton = jQ(selectors.dropdownTriggerButton);
		const option = jQ(selectors.option);

		option.click(function (e) {
			e.preventDefault();

			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		dropdownTrigger.click(function () {
			dropdownTrigger.toggleClass('active');
		});

		jQ(document).on("click", function (e) {
			if (jQ(e.target).is(dropdownTrigger) === false && jQ(e.target).is(dropdownTriggerButton) === false) {
				jQ(dropdownTrigger).removeClass("active");
			}
		});
	};
	/************************** END BUILD TOOLBAR **************************/

	/************************** BUILD ADDITIONAL ELEMENTS **************************/
	ProductList.prototype.beforeRender = function () {
		const currentPage = Globals.queryParams.page ?? null;

		if (!currentPage) {
			productGridItemIndex = 1;

			return null;
		}

		productGridItemIndex = currentPage <= 1 ? 1 : productGridItemIndex;
	};

    function formRequest(value) {
      return new Promise((resolve, reject) => {
          var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
          xhr.open("GET", value);
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.onload = () => resolve(xhr.responseText);
          xhr.onerror = () => reject(xhr.statusText);
          xhr.send();
      });
    }
	ProductList.prototype.afterRender = function (data) {
		if (!data) {
			data = this.data;
		}
        // B2B Price Boost 193094
        for (var item of data) {
          var valueRequest = Shopify.routes.root + 'products/'+ item.handle +'?view=boost-card-product-price';
          var requestReg = formRequest(valueRequest);
                requestReg.then((res_success) => {
                  var parse_res_success = JSON.parse(res_success);
                  var itemEl = jQ('.boost-pfs__product-item[data-card-price="' + parse_res_success.id + '"]');
                  if (itemEl.length > 0) {
                    itemEl.find('.card__price').html(parse_res_success.product_price);
                    itemEl.find('.card__form .product-form__input--dropdown .select select').html(parse_res_success.card_form);
                    itemEl.find('.card__form .card__form-fields .button.button--primary span[data-product-price]').html(parse_res_success.card_form_button);
                  }
                }).catch((res_error) => {
                  console.log(res_error)
                });
        }
        // END B2B Price Boost 193094
		// BonusSeedsCollectionCLassInit
		if (window.boostPFSThemeConfig?.custom?.is_bonus_seeds) {

			if (this.bonusSeedsInit) {
				document.dispatchEvent(new CustomEvent('updateBonusSeedsCollection', {
						detail: data
					})
				);
			} else {
				document.dispatchEvent(new CustomEvent('initBonusSeedsCollection', {
						detail: data
					})
				);

				this.bonusSeedsInit = true;
			}
		}




		// Integrate Swym Wishlist
		/** Start Swym integration **/
		window.SwymCallbacks = window.SwymCallbacks || [];
		window.SwymCallbacks.push(function(swat) {
			// Wrap with callback for loading without additional checks
			var products = [];
			data.forEach(function(product) {
				var image_src = Utils.getFeaturedImage(product.images_info);
				var productCopy = product;
				productCopy.featured_image = image_src;
				productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
				productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
				products.push(productCopy);
			});
			swat.mapShopifyProducts(products); // Product mapped data to swym layer
			swat.initializeActionButtons('[data-collection-products-column]'); // Buttons can now be initialized
		});
		/** End Swym integration **/

		initProductCards();

		function initProductCards() {
			document.dispatchEvent(new CustomEvent("product-cards:init"));
		}
	};

	Filter.prototype.afterRender = function (data) {
		if (!data) {
			data = this.data;
		}

		const selectors = {
			boost: {
				noResultsText: '.product-list-no-search-result-text',
				filterSkeletonButton: '.boost-pfs-filter-skeleton-button',
				imageLoadingAnimation: '[data-boost-image-loading-animation]',
				productsCount: '.boost-pfs-filter-total-product'
			},
			products: "[data-collection-products]",
			progress: {
				indicator: '[data-pagination-progress-indicator]'
			},
			sorting: {
				desktop: "[data-collection-sorting]"
			},
			columns: {
				filter: "[data-collection-filters-column]",
				products: "[data-collection-products-column]"
			}
		};

		const attributes = {
			boost: {
				imageLoadingAnimation: 'data-boost-image-loading-animation'
			}
		};

		const modifiers = {
			hidden: "hidden",
			columns: {
				fullwidth: "collection__col--fullwidth"
			}
		};

		const $body = jQ('body');

		const $products = jQ(selectors.products);

		removeSkeletonButton();
		removeImageLoadingAnimation();

		hideFilterColumnIfNoResults();
		setProductsCount();
		updateProgress();

		function removeSkeletonButton() {
			const skeletonButton = $body.find(selectors.boost.filterSkeletonButton);

			if (!skeletonButton.length) {
				return false;
			}

			$body.find(selectors.boost.filterSkeletonButton).remove();
		}

		function removeImageLoadingAnimation() {
			const $loadingImages = $products.find(selectors.boost.imageLoadingAnimation);

			if (!$loadingImages.length) {
				return false;
			}

			$loadingImages.removeAttr(attributes.boost.imageLoadingAnimation);
		}

		function hideFilterColumnIfNoResults() {
			const filtersColumn = document.querySelector(selectors.columns.filter);
			const productsColumn = document.querySelector(selectors.columns.products);

			if (!filtersColumn || !productsColumn) {
				return false;
			}

			const noResultsText = document.querySelector(selectors.boost.noResultsText);

			const sorting = document.querySelector(selectors.sorting.desktop);

			if (!noResultsText) {
				filtersColumn.classList.remove(modifiers.hidden);
				productsColumn.classList.remove(modifiers.columns.fullwidth);

				if (sorting) {
					sorting.classList.remove(modifiers.hidden);
				}

				return false;
			}

			filtersColumn.classList.add(modifiers.hidden);
			productsColumn.classList.add(modifiers.columns.fullwidth);

			if (sorting) {
				sorting.classList.add(modifiers.hidden);
			}
		}

		function setProductsCount() {
			const container = document.querySelector(selectors.boost.productsCount);

			if (!container) {
				return false;
			}

			let productCount = +data.total_product;

				console.log(window.location);

			productCount = `${productCount} ${productCount === 1 ? boostPFSConfig.label.items_with_count_one : boostPFSConfig.label.items_with_count_other}`;

			container.innerHTML = productCount;
		}

		function updateProgress() {
			const progressBarIndicator = document.querySelector(selectors.progress.indicator);

			if (!progressBarIndicator) {
				return false;
			}

			let totalCount = +data.total_product;
			let productsPerPage = boostPFSFilterConfig.general.limit;

			let currentPage = parseInt(Globals.queryParams.page);

			let viewedCount = currentPage * productsPerPage;

			if (viewedCount >= totalCount) {
				viewedCount = totalCount;
			}

			const progressValue = viewedCount / totalCount * 100;

			progressBarIndicator.style.width = `${progressValue}%`;
		}
	};

	FilterResult.prototype.afterRender = function () {
		const selectors = {
			products: '[data-collection-products]'
		};

		const modifiers = {
			loading: 'boost-loading'
		};

		jQ(selectors.products).removeClass(modifiers.loading);
	};
	/************************** END BUILD ADDITIONAL ELEMENTS **************************/

	/************************** START HELPERS **************************/
	function getMetafieldValue(product, namespace, key) {
		const metafield = product.metafields.find(
			metafield => metafield.namespace === namespace && metafield.key === key
		);

		if (!metafield) {
			return null;
		}

		try {
			return JSON.parse(metafield.value);
		} catch {
			return metafield.value;
		}
	}
	/************************** END HELPERS **************************/

    FilterApi.beforeCall = function(eventType, eventInfo) {
      var hideNonWholeSale = true;
      var customerTags = boostPFSConfig.customer.tags
      if(customerTags?.includes('loyalty::tier::gold-stockists') || customerTags?.includes('loyalty::tier::silver-stockists')) {
         hideNonWholeSale = true;
      }else{
         for (let i = 0; i < customerTags?.length; i++) {
           if(customerTags[i].includes('loyalty::tier::')){
             hideNonWholeSale = false;
             break;
           }
         }
      }
      Globals.queryParams.h_options = [];
      if (hideNonWholeSale) {
        Globals.queryParams.h_options.push('guest');
      }
    }

})();
